import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface StrategyMapHeaderInfoTagProps {
  label: string;
  icon: IconDefinition;
  children: React.ReactNode;
}

const StrategyMapHeaderInfoTag: React.FC<StrategyMapHeaderInfoTagProps> = ({
  label,
  icon,
  children,
}) => {
  return (
    <div className="px-1.5 py-1 bg-sky-50 rounded-md flex justify-center items-center gap-1 overflow-hidden">
      <div className="w-3 h-3 flex items-center justify-center flex-shrink-0">
        <Icon icon={icon} size="sm" className="text-sky-800 w-2 h-2.5" />
      </div>
      <div className="flex items-center justify-start gap-0.5 text-sky-800 text-xs font-normal font-['Inter'] leading-4">
        <span>{label}:</span>
        {children}
      </div>
    </div>
  );
};

export default StrategyMapHeaderInfoTag;
